module.exports = __webpack_public_path__ + "static/media/logo.53a6df7f.png";